import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/general-stats/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const generalStats = {
  get: apiPathFunc(pathBase),
} as const;
